<template>
  <div>
    <Top></Top>
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img :src="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop"></div>
          <div class="contentBottom">
            <div>以客户为中心，高效、极致、分享</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <!-- <div class="titleBox">
      <div class="anliTitle">公司简介</div>
      <div class="lineCss"></div>
    </div>-->
    <!-- start -->
    <div class="aboutUs">
      <div class="aboutUsTitle">智见未来,屏幕化引领生活</div>
      <div class="aboutUsText">
        数拓科技，是一家专注于智能商显管理平台与智能交互应用研发的互联网公司。自主研发线上SAAS+线下方案快速交付平台，独创场景化大屏应用市场，并打造集终端显示硬件、智能感知套件、软件应用、智能OS、云服务于一体的智慧商显生态链。
        数拓开放性的平台理念，能快速整合上游硬件行业的制造红利，协同互联网平台资源，以极致的产品体验，为合作伙伴带来价值，为新商业生态带来价值。
        数拓产品已覆盖餐饮、零售、服装、院线等多个行业，并得到各细分行业领头羊企业的认可，包括万达院线，海底捞，热风，GXG，镜尚传媒等。目前，数拓服务已承载超30万屏幕终端。覆盖国内城市330座，国外城市28座。
      </div>
    </div>
    <!-- end -->

    <!-- bottomContent start -->
    <div class="bottomContent">
      <div class="yellowBox"></div>
      <div class="stepCss">
        <div class="titleBox">
          <div class="anliTitle marginTop160">数拓荣誉</div>
          <div class="lineCss"></div>
        </div>
        <!-- <el-steps direction="vertical" :active="1">
          <el-step title=" 1" description="这是一段很长很长很长的描述性文字这是一段很长很长很长的描述性文字这是一段很长很长很长的描述性文字这是一段很长很长很长的描述性文字"></el-step>
          <el-step title=" 2" description="这是一段很长很这是一段很长很长很长的描述性文字长很长的描述性文字"></el-step>
          <el-step title=" 3" description="这是一段很长很长很长的描述性文字"></el-step>
        </el-steps>-->
        <!-- start -->
        <div class="conentParent">
          <div class="contentLeft" :style="{height:height2019}">
            <div class="leftPosition">
              <img :src="contentLeftIcon" alt>
              <span class="iconIright">2019</span>
            </div>
          </div>
          <div class="contentRight" ref="elememt2019">
            <div>1月11日阿里授予“新零售杰出生态伙伴”</div>
            <div class='marginTop37'>1月11日商显行业促进会授予“新零售最佳方案奖”</div>
          </div>
          <div class="contentLeft" :style="{height:height2018}">
            <div class="leftPosition">
              <img :src="contentLeftIcon" alt>
              <span class="iconIright">2018</span>
            </div>
          </div>
          <div class="contentRight" ref="elememt2018">
            <div>12月18日 海底捞授予“最佳创意IT供应商”</div>
            <div class="marginTop37">12月05日商显行业促进会授予“新零售最佳方案应用奖”</div>
            <div class="marginTop37">08月28日阿里授予“新零售银牌伙伴”</div>
            <div class="marginTop37">04月11日阿里授予“新零售智能硬件JBP服务商”</div>
          </div>
          <div class="contentLeft" :style="{height:height2017}">
            <div class="leftPosition">
              <img :src="contentLeftIcon" alt>
              <span class="iconIright">2017</span>
            </div>
          </div>
          <div class="contentRight" ref="elememt2017">
            <div class>11月2017深圳创新南山创业之星大赛授予“初创团队年度优胜奖”</div>
             <div class="marginTop37">11月24日第九届中国连锁峰会授予“2016年度最佳连锁服务商”</div>
             <div class="marginTop37">10月第十五届中国国际中小企业博览会授予“智能服饰创新型企业”</div>
            <div class="marginTop37">9月6日阿里巴巴诸神之战全球创客大赛授予“陕西赛区亚军”</div>
            <div class="marginTop37">
              9月第四届中国创新创业大赛暨第二届陕西省科技创新创业大赛授予
              “互联网及移动互联网一等奖”
            </div>
            <div class="marginTop37">8月2017“物联中国”陕西赛区授予“物联中国三等奖”</div>
          </div>
          <div class="contentLeft" :style="{height:height2016}">
            <div class="leftPosition">
              <img :src="contentLeftIcon" alt>
              <span class="iconIright">2016</span>
            </div>
          </div>
          <div class="contentRight" ref="elememt2016">
            <div class>11月24日第九届中国连锁峰会授予“2016年度最佳连锁服务商”</div>
            <div class="marginTop37">10月第十五届中国国际中小企业博览会授予“智能服饰创新型企业”</div>
            <div class="marginTop37">
              9月第四届中国创新创业大赛暨第二届陕西省科技创新创业大赛授予
              “互联网及移动互联网一等奖”
            </div>
          </div>
          <div class="contentLeft">
            <div class="leftPosition">
              <img :src="contentLeftIcon" alt>
              <span class="iconIright">2015</span>
            </div>
          </div>
          <div class="contentRight">
            03月20日第五届数字标牌行业高峰论坛授予“多媒体信息发布系
            统最佳新锐品牌
          </div>
        </div>
        <!-- end -->
      </div>
    </div>
    <!-- bottomContent end -->
    <!-- 轮播 start -->
    <div class="swiperParent">
      <div class="keHuSwiperUs">
        <div class="swiper-containerKeHu">
          <div class="swiper-wrapper swiper-no-swiping">
            <div class="swiper-slide">
              <img :src="usBottom1" alt>
            </div>
            <div class="swiper-slide">
              <img :src="usBottom2" alt>
            </div>
            <div class="swiper-slide">
              <img :src="usBottom3" alt>
            </div>
            <div class="swiper-slide">
              <img :src="usBottom4" alt>
            </div>
            <div class="swiper-slide">
              <img :src="usBottom5" alt>
            </div>
            <div class="swiper-slide">
              <img :src="usBottom6" alt>
            </div>
            <div class="swiper-slide">
              <img :src="usBottom7" alt>
            </div>
            <div class="swiper-slide">
              <img :src="usBottom8" alt>
            </div>
            <div class="swiper-slide">
              <img :src="usBottom9" alt>
            </div>
            <div class="swiper-slide">
              <img :src="usBottom10" alt>
            </div>
            <div class="swiper-slide">
              <img :src="zhengShu11" alt>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 轮播 end -->
    <Footer :isMarginTop="true"></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/aboutShuoTuoTop.png";
import contentLeftIcon from "@/assets/images/contentLeftIcon.png";
import usBottom1 from "@/assets/images/usBottom1.png";
import usBottom2 from "@/assets/images/usBottom2.png";
import usBottom3 from "@/assets/images/usBottom3.png";
import usBottom4 from "@/assets/images/usBottom4.png";
import usBottom5 from "@/assets/images/usBottom5.png";
import usBottom6 from "@/assets/images/usBottom6.png";
import usBottom7 from "@/assets/images/usBottom7.png";
import usBottom8 from "@/assets/images/usBottom8.png";
import usBottom9 from "@/assets/images/usBottom9.png";
import usBottom10 from "@/assets/images/usBottom10.png";
import zhengShu11 from "@/assets/images/zhengShu11.jpg";
import Bread from "@/components/bread.vue";

export default {
  name: "AboutUs",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      toBreadChild: ["我们"],
      bgImg: bgImg,
      contentLeftIcon: contentLeftIcon,
      height2019: "",
      height2018: "",
      height2017: "",
      height2016: "",
      height2015: "",
      usBottom1: usBottom1,
      usBottom2: usBottom2,
      usBottom3: usBottom3,
      usBottom4: usBottom4,
      usBottom5: usBottom5,
      usBottom6: usBottom6,
      usBottom7: usBottom7,
      usBottom8: usBottom8,
      usBottom9: usBottom9,
      usBottom10: usBottom10,
      zhengShu11: zhengShu11,
      swiperKeHu: ""
    };
  },
  mounted() {
    this.height2019 = this.$refs.elememt2019.offsetHeight + 15 + "px";
    this.height2018 = this.$refs.elememt2018.offsetHeight + 15 + "px";
    this.height2017 = this.$refs.elememt2017.offsetHeight + 15 + "px";
    this.height2016 = this.$refs.elememt2016.offsetHeight + 15 + "px";
    this.swiperKeHu = new Swiper(".swiper-containerKeHu", {
      slidesPerView: 5,
      autoplayDisableOnInteraction: false,
      freeMode: true,
      autoplay: {
        delay: 0
      },
      loop: true, //循环
      speed: 4000
    });
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 160px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 69px;
}

.contentBottom {
  text-align: center;
  font-size: 5.2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
.anliTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
  margin-bottom: 100px;
}

.titleBox {
  text-align: center;
  margin-top: 70px;
}

.aboutUs {
  width: 55%;
  min-width: 750px;
  margin: auto;
  text-align: center;
}

.aboutUsTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 80px;
  margin-bottom: 35px;
}

.aboutUsText {
  font-size: 1.6rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 32px;
  text-align: left;
  text-indent: 3.2rem;
}

.marginTop160 {
  margin-top: 30px;
}

.bottomContent {
  background: rgba(240, 240, 240, 1);
  margin-top: 68px;
  padding-bottom: 80px;
}

.yellowBox {
  width: 18%;
  height: 60px;
  background: rgba(252, 200, 0, 1);
}

.stepCss {
  width: 65%;
  min-width: 876px;
  margin: auto;
  /* height: 1500px; */
  margin-top: 72px;
  min-width: 810px;
}

.conentParent::after {
  content: "";
  display: block;
  clear: both;
}

.conentParent {
  margin-top: 32px;
}

.contentLeft {
  width: 14%;
  float: left;
  border-left: 1px dashed #666;
  position: relative;
  margin-top: 17px;
}

.contentRight {
  width: 74%;
  float: right;
  font-size: 2.4rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  background: #fff;
  padding: 24px 48px;
  margin-bottom: 32px;
}

.iconIright {
  font-size: 2.4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 32px;
}

.leftPosition {
  position: absolute;
  left: -9px;
  top: -22px;
}
.marginTop37 {
  padding-top: 37px;
}
@media screen and (max-width: 1125px) {
}
.keHuSwiperUs {
  width: 65%;
  min-width: 810px;
  margin: auto;
  overflow: hidden;
  border: 1px solid #eee;
}
.swiperParent {
  padding-bottom: 90px;
  background: rgb(240, 240, 240);
}
.swiper-slide img {
  width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/view/AboutUs.vue